export default {
  methods: {
    prettyFileSize(size) {
      const kilobyte = 1000;
      const megabytes = kilobyte * 1000;
      const gigabytes = megabytes * 1000;

      if (size) {
        if (size > gigabytes) {
          return `${(size / gigabytes).toFixed(2)} GB`;
        }
        if (size > megabytes) {
          return `${(size / megabytes).toFixed(2)} MB`;
        }
        return `${(size / kilobyte).toFixed(2)} KB`;
      }
      return '0 KB';
    },
    transfromByteToBit(size) {
      const sizeBites = size * 8;
      const kilobites = 1000;
      const megabites = kilobites * 1000;
      const gigabites = megabites * 1000;
      if (sizeBites) {
        if (sizeBites > gigabites) {
          return `${(sizeBites / gigabites).toFixed(2)} Gbit`;
        }
        if (sizeBites > megabites) {
          return `${(sizeBites / megabites).toFixed(2)} Mbit`;
        }
        return `${(sizeBites / kilobites).toFixed(2)} kbit`;
      }
      return '0 kbit';
    },
  },
};
